export default "__VITE_ASSET__BVwNsxqV__"